<template>
  <div
    id="ssr-page"
    class="ssr-page"
    :class="[lang, { 'transparent-bg-mode': isTransparentBgMode }]"
  >
    <transition :name="transitionName">
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </transition>
  </div>
</template>
<script>
import globalConfig from '@utiles/officialStore/globalConfig';
import transparentBg from '@mixins/officialWebStore/transparentBg';
const changeTheme = gameCode => {
  document.documentElement.classList.add(gameCode);
  document.body.classList.add(gameCode);
};
const initColorConfig = colorConfig => {
  Object.keys(colorConfig).forEach(item => {
    document.documentElement.style.setProperty(`--${item}`, colorConfig[item]);
    document.body.style.setProperty(`--${item}`, colorConfig[item]);
  });
};
export default {
  mixins: [transparentBg],
  data() {
    return {
      transitionName: ''
    };
  },
  computed: {
    gameId() {
      return this.$store.state.gameId;
    },
    lang() {
      return this.$store.state.lang;
    },
    colorConfig() {
      return this?.gameInfoConfig?.colorConfig || {};
    },
    gameInfoConfig() {
      return this?.$store?.getters?.gameInfoConfig;
    },
    pageInfo() {
      return this.gameInfoConfig?.pageInfo || {};
    }
  },
  watch: {
    gameId: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          return;
        }
        initColorConfig(this.colorConfig);
        globalConfig.setPageTitleAndIco(
          this.pageInfo?.pageTitle || '',
          this.pageInfo?.pageIco || '',
          this.pageInfo?.keywords || '',
          this.pageInfo?.description || ''
        );
        this.pageInfo?.appleTouchIcon &&
          globalConfig.addAppleTouchIcon(this.pageInfo.appleTouchIcon);
        changeTheme(this.$store.getters.gameInfoConfig.gameCode);
      }
    }
  },
  beforeCreate() {
    const preLanguage = globalConfig.getHrefParamUndecode('language');
    if (preLanguage) {
      globalConfig.setLclStorageItem(
        globalConfig.getPageLangStorageKey(),
        preLanguage
      );
    }
    globalConfig.setRouterQuery(this.$route.query);
    globalConfig.setRoute(this.$route);
    globalConfig.init();
  }
};
</script>
<style>
html {
  width: 100%;
  height: 100%;
}
body {
  margin: 0;
  width: 100%;
  height: 100%;
}
.ssr-page {
  width: 100%;
  height: 100%;
  font-size: 0;
}
</style>
<style lang="scss">
@import '@assets/scss/officialWebStore/base.scss';
@import '@assets/scss/officialWebStore/animate.scss';
@import '@assets/scss/officialWebStore/common.scss';
@import '@assets/scss/officialWebStore/font/iconfont.scss';
@import '@assets/scss/officialWebStore/officialWebStore.scss';
#ssr-page.transparent-bg-mode {
  background-color: transparent !important;
}
</style>
